import {
	PropsWithChildren,
	ReactElement,
	useMemo
} from "react";
import { TileContextData, TileContext } from "./Tiles/TileContext";
import { TileRenderState } from "./RenderState/common";

export type TileContextProviderProps = {
	renderState: TileRenderState<any>;
};

export const TileContextProvider = (props: PropsWithChildren<TileContextProviderProps>): ReactElement => {
	const {
		renderState,
		children
	} = props;

	const {
		data: {
			id,
			color,
			icon,
			name,
			environmentAppId,
			conditionalAccess,
			maintenanceWindow,
			appIsLicensed,
			appIsNotAccessible,
			shouldHideName
		},
		dimension,
		interactionState,
	} = renderState;

	const tileContextData = useMemo(
		(): TileContextData => ({
			id,
			dimension,
			color,
			icon,
			name,
			environmentAppId,
			interactionState,
			conditionalAccess,
			maintenanceWindow,
			appIsLicensed,
			appIsNotAccessible,
			shouldHideName
		}),
		[
			color,
			conditionalAccess,
			dimension,
			environmentAppId,
			icon,
			id,
			interactionState,
			maintenanceWindow,
			name,
			appIsLicensed,
			appIsNotAccessible,
			shouldHideName
		]
	);

	return (
		<TileContext.Provider value={tileContextData}>
			{children}
		</TileContext.Provider>
	);
};
TileContextProvider.displayName = "TileContextProvider";
